import { render, staticRenderFns } from "./DashboardNewJobs.vue?vue&type=template&id=f931f440&scoped=true&"
import script from "./DashboardNewJobs.vue?vue&type=script&lang=js&"
export * from "./DashboardNewJobs.vue?vue&type=script&lang=js&"
import style0 from "./DashboardNewJobs.vue?vue&type=style&index=0&id=f931f440&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f931f440",
  null
  
)

export default component.exports